<template>
  <div v-if="materiel && faces">
    <div class="level level-right">
      <router-link
        :to="{ name: 'm.gabed.emplacement-faceEdition',
          params: {
            idMateriel: materiel.id,
            idFace: 1,
        }}"
        class="button is-addOrEdit"
        :class="{'button-access-no-permission':
          !checkPermissions(constantes.permEmplacement.maj)}">
        {{$t('face.ajouterFace')}}
      </router-link>
    </div>
    <v-client-table
      :data="faces"
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      class="displayNoneVuePagination"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering">
      <div slot="code" slot-scope="props">
        <router-link :to="getDetailsOrEditRoute(props.row, false)"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(constantes.permEmplacement.lecture)}">
          {{ props.row.code }}
        </router-link>
      </div>
      <div slot="actif" slot-scope="props">
        <div>{{ props.row.actif ? $t('general.non') : $t('general.oui') }}</div>
      </div>
      <div slot="materiel.dispositif.adresse" slot-scope="props">
        {{ props.row.materiel.dispositif.adresse | adresse }}
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatMontage(props.row.etat)) }}
      </div>
      <div slot="materiel.format.libelle" slot-scope="props">
        {{ props.row.materiel.format ? props.row.materiel.format.libelle : '' }}
      </div>
      <div slot="materiel.type.libelle" slot-scope="props">
        {{ props.row.materiel.type ? props.row.materiel.type.libelle : '' }}
      </div>
      <div slot="materiel.dispositif.dispositifType.libelle" slot-scope="props">
        {{ props.row.materiel.dispositif && props.row.materiel.dispositif.dispositifType ?
        props.row.materiel.dispositif.dispositifType.libelle : '' }}
      </div>
      <div slot="materiel.dispositif.dispositifSupport.libelle" slot-scope="props">
        {{ props.row.materiel.dispositif && props.row.materiel.dispositif.dispositifSupport ?
        props.row.materiel.dispositif.dispositifSupport.libelle : '' }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.materiel.dispositif.emplacement.agenceId) }}
      </div>
      <div slot="actions" slot-scope="props">
        <verticalDotsDropdown
          :dropdownItems="dropdownItems(props.row)"
          :isButton="false"/>
      </div>
    </v-client-table>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        v-if="faceToArchive"
          @no="openPopUpPrevention = false"
          @yes="archiverFace"
          :messagesPopup="messagesErreurPopUp"
          :isErrorPopup.sync="errorPopUp"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          :mess-header="$t(('listeFace.archivageDesarchiver.'
          + (faceToArchive.actif ? 'archivage' : 'desarchivage')))">
        </pop-up-prevention>
      </b-modal>
      <b-modal v-model="openPopUpPreventionSuppression"
             has-modal-card
             class="modal">
        <pop-up-prevention
          @no="openPopUpPreventionSuppression = false"
          @yes="supprimerFace"
          :messagesPopup="messagesErreurPopUp"
          :isErrorPopup.sync="errorPopUp"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          :mess-header="$t('listeFace.supprimer.titre')">
        </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import { REFERENCE_TABLE_FACES } from '@/configuration/general/referenceTableConf';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import { getAll, deleteFace, archiver } from '@/api/gabed/face';
import { get } from '@/api/gabed/materiel';
import { columnsSplice } from '@/services/general/columns';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import validationDeleteFace from '@/services/gabed/face/validationDeleteFace';
import validationFace from '@/services/gabed/face/validationFace';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      faces: null,
      materiel: null,
      constantes: {
        permEmplacement: EMPLACEMENT,
      },
      referenceTable: REFERENCE_TABLE_FACES,
      startArrayRendering: false,
      faceToArchive: null,
      openPopUpPrevention: false,
      openPopUpPreventionSuppression: false,
      messagesErreurPopUp: [],
      errorPopUp: false,
    };
  },
  components: {
    verticalDotsDropdown,
    popUpPrevention,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    columns() {
      const columns = ['code', 'disposition', 'materiel.format.libelle', 'materiel.type.libelle', 'materiel.dispositif.dispositifType.libelle', 'materiel.dispositif.dispositifSupport.libelle', 'etat', 'materiel.dispositif.adresse', 'actif', 'agence', 'actions'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      if (!this.showPerPage) texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeFace.tab.codeFace'),
          'materiel.disposition': this.$i18n.t('listeFace.tab.disposition'),
          'materiel.format.libelle': this.$i18n.t('listeFace.tab.format'),
          'materiel.type.libelle': this.$i18n.t('listeFace.tab.typeMateriel'),
          'materiel.dispositif.dispositifType.libelle': this.$i18n.t('listeFace.tab.typeDispositif'),
          'materiel.dispositif.dispositifSupport.libelle': this.$i18n.t('listeFace.tab.support'),
          etat: this.$i18n.t('listeFace.tab.etatMontage'),
          'materiel.dispositif.adresse': this.$i18n.t('listeFace.tab.adresse'),
          actif: this.$i18n.t('listeFace.tab.archive'),
          agence: this.$i18n.t('listeFace.tab.agence'),
          actions: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: NO_PAGINATION,
        texts: texts,
        sortable: ['materiel.code', 'code', 'materiel.disposition', 'materiel.format.libelle', 'materiel.type.libelle', 'materiel.dispositif.dispositifType.libelle', 'materiel.dispositif.dispositifSupport.libelle', 'etat', 'materiel.dispositif.adresse'],
      };
    },
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  methods: {
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    getDetailsOrEditRoute(face, isEdit) {
      return {
        name: isEdit ? 'm.gabed.emplacement-faceEdition' : 'c.gabed.emplacement-face',
        params: {
          idMateriel: face.materiel.id,
          idFace: face.id,
        },
      };
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    showPopUpArchivage(faceToArchive) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.openPopUpPrevention = true;
      this.faceToArchive = faceToArchive;
    },
    dropdownItems(row) {
      return [
        {
          action: () => { this.showPopUpArchivage(row); },
          libelle: this.$i18n.t('listeFace.actions.'
           + (row.actif ? 'archiverFace' : 'desarchiverFace')),
          permission: this.constantes.permEmplacement.supprimer,
        },
        {
          action: () => {
            this.idFace = row.id;
            this.errorPopUp = false;
            this.messagesErreurPopUp = [];
            this.openPopUpPreventionSuppression = true;
          },
          libelle: this.$t('general.button.delete'),
          permissionAction: this.constantes.permEmplacement.supprimer,
        },
      ];
    },
    async loadFaces() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const dataBody = {
          query: {
            materielIds: [this.materiel.id],
            societeId: this.societeActiveId,
            nonCommercialisable: null,
          },
        };
        this.faces = (await getAll(dataBody)).data.result.items;
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async archiverFace() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const id = this.faceToArchive.id;
        const actif = this.faceToArchive.actif;
        await archiver(id, actif);
        messageSucces(this.$i18n.t('materiel.messages.success.' + (this.faceToArchive.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpPrevention = false;
        await this.loadFaces();
      } catch (e) {
        if (e.response?.data?.error) {
          validationFace(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async supprimerFace() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await deleteFace(this.idFace);
        messageSucces(this.$t('materiel.messages.success.supprimer'));
        this.openPopUpPreventionSuppression = false;
        await this.loadFaces();
      } catch (e) {
        if (e.response.data.error) {
          validationDeleteFace(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.materiel = (await get(this.$route.params.idMateriel)).data.result;
      const dataBody = {
        query: {
          materielIds: [this.materiel.id],
          societeId: this.societeActiveId,
          nonCommercialisable: null,
        },
      };
      this.faces = (await getAll(dataBody)).data.result.items;
      this.startArrayRendering = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
